// @flow
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import {
  editarCompradores,
  getCompradoresSelecionados,
} from "../../../../state";
import { VALOR_DEFAULT_COMPRADORES } from "../../../../model";

import "./Compradores.css";

const Compradores = () => {
  const dispatch = useDispatch();

  const compradores = useSelector(getCompradoresSelecionados);

  const aoMudarValor = React.useCallback(
    compradores => {
      dispatch(editarCompradores(compradores));
    },
    [dispatch]
  );

  const aoTirarFoco = React.useCallback(() => {
    if (!compradores) dispatch(editarCompradores(VALOR_DEFAULT_COMPRADORES));
  }, [dispatch, compradores]);

  return (
    <div className="ConfiguracaoCompradores">
      <label className="ConfiguracaoMedida__label">
        <Translate>Comum.Compradores</Translate>
      </label>
      <NumberField
        className="ConfiguracaoMedida__input"
        allowNegative={false}
        onlyInteger
        min={1}
        max={100}
        value={compradores}
        onChangeValue={aoMudarValor}
        onBlur={aoTirarFoco}
      >
        <label className="ConfiguracaoMedida__label">
          <Translate>Comum.Maiores</Translate>
        </label>
      </NumberField>
    </div>
  );
};

export default Compradores;
